import axios from 'axios';

const API_BASE_URL = 'https://api.thunderbirdsmoke.net';

// Helper to add Authorization header
export const authHeader = () => {
  const token = localStorage.getItem('authToken'); // Retrieve the token from localStorage
  if (!token) {
    throw new Error('No auth token found');
  }
  return { Authorization: `Bearer ${token}` };
};

export const fetchKPIs = async () => {
  const response = await axios.get(`${API_BASE_URL}/analytics/kpis`, {
    headers: authHeader(),
  });
  return response.data;
};

export const fetchSalesTrend = async () => {
  const response = await axios.get(`${API_BASE_URL}/analytics/sales-trend`, {
    headers: authHeader(),
  });
  return response.data;
};

export const fetchInventoryDistribution = async () => {
  const response = await axios.get(`${API_BASE_URL}/analytics/inventory-distribution`, {
    headers: authHeader(),
  });
  return response.data;
};

export const fetchSalesByLocation = async () => {
  const response = await axios.get(`${API_BASE_URL}/analytics/sales-by-location`, {
    headers: authHeader(),
  });
  return response.data;
};

export const fetchCategories = async () => {
  const response = await axios.get(`${API_BASE_URL}/categories`, {
    headers: authHeader(),
  });
  return response.data.categories;
};

export const fetchLocations = async () => {
  const response = await axios.get(`${API_BASE_URL}/locations`, {
    headers: authHeader(),
  });
  return response.data.locations;
};